import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getTaxReceipts } from '@sola/proxy-sdk/utils/routes.ts';
import { QUERY_KEYS } from '../constants.ts';
import { useReadyForQueries } from './base.ts';

/**
 * Hook to fetch tax receipts.
 */
export const useTaxReceipts = () => {
  const $ = _c(7);
  const {
    isReady,
    globalId
  } = useReadyForQueries();
  let t0;
  let t1;
  if ($[0] !== globalId) {
    t0 = [QUERY_KEYS.supporterTaxReceipts, globalId];
    t1 = () => getTaxReceipts(globalId);
    $[0] = globalId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isReady || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      refetchOnWindowFocus: false,
      enabled: isReady,
      staleTime: Infinity
    };
    $[3] = isReady;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};